export const ASSET_STATUS_LIST = "ASSET_STATUS_LIST";
export const ASSET_STATUS_LIST_SUCCESS = "ASSET_STATUS_LIST_SUCCESS";
export const ASSET_STATUS_LIST_FAILURE = "ASSET_STATUS_LIST_FAILURE";

export const ASSET_STATUS_DATA = "ASSET_STATUS_DATA";
export const ASSET_STATUS_DATA_SUCCESS = "ASSET_STATUS_DATA_SUCCESS";
export const ASSET_STATUS_DATA_FAILURE = "ASSET_STATUS_DATA_FAILURE";

export const ASSET_STATUS_CREATE = "ASSET_STATUS_CREATE";
export const ASSET_STATUS_CREATE_SUCCESS = "ASSET_STATUS_CREATE_SUCCESS";
export const ASSET_STATUS_CREATE_FAILURE = "ASSET_STATUS_CREATE_FAILURE";

export const ASSET_STATUS_UPDATE = "ASSET_STATUS_UPDATE";
export const ASSET_STATUS_UPDATE_SUCCESS = "ASSET_STATUS_UPDATE_SUCCESS";
export const ASSET_STATUS_UPDATE_FAILURE = "ASSET_STATUS_UPDATE_FAILURE";

export const ASSET_STATUS_DELETE = "ASSET_STATUS_DELETE";
export const ASSET_STATUS_DELETE_SUCCESS = "ASSET_STATUS_DELETE_SUCCESS";
export const ASSET_STATUS_DELETE_FAILURE = "ASSET_STATUS_DELETE_FAILURE";